import Clipboard from 'clipboard';
import useAlert from '@global/composable/useAlert';

const { alertDialog } = useAlert();

function shareToSocial(event, url) {
  const target = event.currentTarget;
  const social = target.getAttribute('data-social');

  setTimeout(() => {
    switch (social) {
      case 'fb':
        window.open(
          `https://www.facebook.com/sharer/sharer.php?u=${url}`,
          '_blank',
          'toolbar=yes,location=yes,directories=no,status=no, menubar=yes,scrollbars=yes,resizable=no, copyhistory=yes,width=600,height=500',
        );
        break;
      case 'line':
        window.open(
          `http://line.naver.jp/R/msg/text/?${url}`,
          '_blank',
          'toolbar=yes,location=yes,directories=no,status=no, menubar=yes,scrollbars=yes,resizable=no, copyhistory=yes,width=600,height=500',
        );
        break;
      case 'IG':
        window.open(
          'https://www.instagram.com',
          '_blank',
          'toolbar=yes,location=yes,directories=no,status=no, menubar=yes,scrollbars=yes,resizable=no, copyhistory=yes,width=600,height=500',
        );
        break;
      case 'twitter':
        window.open(
          `https://twitter.com/share?url=${url}`,
          '_blank',
          'toolbar=yes,location=yes,directories=no,status=no, menubar=yes,scrollbars=yes,resizable=no, copyhistory=yes,width=600,height=500',
        );
        break;
      case 'whatsapp':
        window.open(
          `https://wa.me/?text=${url}`,
          '_blank',
          'toolbar=yes,location=yes,directories=no,status=no, menubar=yes,scrollbars=yes,resizable=no, copyhistory=yes,width=600,height=500',
        );
        break;
      case 'wechat':
        window.location.href = 'https://web.wechat.com/?url=';
        break;
      default:
        window.location.href = '';
        break;
    }
  });
}

function copy(closeFunc) {
  const clipboard = new Clipboard('#copyLink');
  clipboard.on('success', (e) => {
    clipboard.destroy();
    alertDialog.alert('網址已複製。', () => {
      closeFunc();
    });
  });

  clipboard.on('error', (e) => {
    clipboard.destroy();
    alertDialog.alert('很抱歉，您的瀏覽器不支援複製網址，您可以手動複製。');
  });
}

function useShare() {
  return { shareToSocial, copy };
}

export default useShare;
